module.exports = __webpack_public_path__ + "img/en.e0890758.png";